// extracted by mini-css-extract-plugin
module.exports = {"skip-btn":"layout_skip-btn__EX__W","skipBtn":"layout_skip-btn__EX__W","now-fresh-padding":"layout_now-fresh-padding__jfQZ5","nowFreshPadding":"layout_now-fresh-padding__jfQZ5"};